import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Servers } from 'src/app/config/api';

@Injectable({
  providedIn: 'root'
})
export class CheckoutService {

  private baseUrl = Servers.MARKET.baseUrl; 

  constructor(private http: HttpClient) {}

  enviar_pedido(data:any): Observable<any> {
    return this.http.post(`${this.baseUrl}send-order-email/`,data);
  }

  
  validar_pedido(pedido_id:any): Observable<any> {
    return this.http.get(`${this.baseUrl}market/estado-pedido/${pedido_id}/`);
  }
  
}
